module.exports = __webpack_public_path__ + "b7f44f79b0a5e81ff93663e4358e872c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lighthouse.png
// module id = 1664
// module chunks = 4